import { render, staticRenderFns } from "./DashboardApp.vue?vue&type=template&id=50159dac&scoped=true"
import script from "./DashboardApp.vue?vue&type=script&lang=js"
export * from "./DashboardApp.vue?vue&type=script&lang=js"
import style0 from "./DashboardApp.vue?vue&type=style&index=0&id=50159dac&prod&lang=scss&scoped=true"
import style1 from "./DashboardApp.vue?vue&type=style&index=1&id=50159dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50159dac",
  null
  
)

export default component.exports